import {
  KpiCardParamsSchema,
  defaultKpiCardParams,
  type KpiCardParams,
} from "@playbookai/widget-schemas";
import type { YjsWidgetDef } from "../types.js";
import { registerWidget } from "../registry.js";
import { paramsFromYMap, paramsToYMap } from "../yjs-params.js";
import { KpiCardWidget } from "./Component.js";

/**
 * kpiCard — Yjs-native headline metric (PB-234). Deliberately a DISTINCT kind
 * from the SQL entity-backed `kpiTile`: the process-global registry allows one
 * def per kind, and `kpiTile` is `storage: "sql"` (needs a resolver + a
 * playbook-be entity Hoshin has no backend for). It used to reuse the tile's
 * params schema, and stopped when the tile became a read-only view of a KPI
 * Manager KPI: `KpiCardParamsSchema` is that pre-binding shape, so this card's
 * stored content, Y.Doc merge behaviour and rendering are all unchanged.
 * Whether Hoshin should ALSO bind to KPI Manager is its own product decision.
 */
/** Only the free-text `label` char-merges; `value`/`unit`/`target`/direction/
 *  `recentValues` are atomic or data-fed, so they stay plain LWW (PB-418 D3).
 *  `sourceText` is not surfaced by this card's editor, so it needs no merge. */
const TEXT_FIELDS = ["label"] as const;

export const kpiCardDef: YjsWidgetDef<KpiCardParams> = {
  kind: "kpiCard",
  label: "KPI tile",
  modes: ["canvas"],
  singleton: false,
  defaultSize: { w: 320, h: 220 },
  defaultParams: defaultKpiCardParams,
  Component: KpiCardWidget,
  storage: "yjs",
  accent: "amber",
  textFields: TEXT_FIELDS,
  paramsFromY: (raw) =>
    paramsFromYMap(raw, KpiCardParamsSchema, defaultKpiCardParams),
  paramsToY: (next) =>
    paramsToYMap(next as Record<string, unknown>, TEXT_FIELDS),
};

registerWidget(kpiCardDef);
